"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const GenericErrorIcon = (props) => {
    return (react_1.default.createElement(react_native_svg_1.Svg, Object.assign({ width: 96, height: 96, viewBox: "0 0 96 96", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement(react_native_svg_1.Path, { d: "M0 0h96v96H0z" }),
            react_1.default.createElement(react_native_svg_1.Path, { d: "M20 20h56v56H20z" }),
            react_1.default.createElement(react_native_svg_1.Path, { d: "M24 24h48v48H24z" }),
            react_1.default.createElement(react_native_svg_1.Path, { d: "m61.732 60.322-13.2-25.2c-.207-.396-.857-.396-1.063 0l-13.2 25.2a.598.598 0 0 0 .531.878h26.4a.6.6 0 0 0 .532-.878zM49.372 43.8l-.686 9.943h-1.372l-.686-9.943h2.744zM48 58.8a1.8 1.8 0 1 1 0-3.6 1.8 1.8 0 0 1 0 3.6z", fill: "#111", fillRule: "nonzero" }))));
};
exports.default = GenericErrorIcon;
